var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "./config";
export const fetchCapaPdf = createAsyncThunk("capaPDF/fetch", (nothing, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f;
    const data = JSON.stringify({
        nome_portfolio: (_b = (_a = thunkAPI.getState().preference) === null || _a === void 0 ? void 0 : _a.params.carteira) !== null && _b !== void 0 ? _b : "",
        abas: ["CapaPDF"],
        recalcular: ((_c = thunkAPI.getState().preference) === null || _c === void 0 ? void 0 : _c.recalcular) ? 1 : 0,
    });
    const token = (_e = (_d = thunkAPI.getState().preference) === null || _d === void 0 ? void 0 : _d.token.value) !== null && _e !== void 0 ? _e : "";
    try {
        const response = yield api(token).post(`API/EndPoint002.php?code=${window.env.REACT_APP_APICODE}&service=CarregaCoreExtratoWhitelabel001`, data);
        if (response.data.msg && response.data.codigo)
            return thunkAPI.rejectWithValue(response.data);
        return response.data;
    }
    catch (error) {
        const err = error;
        return thunkAPI.rejectWithValue((_f = err.response) === null || _f === void 0 ? void 0 : _f.data);
    }
}));
